<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <Box theme="box-primary" title="Tìm kiếm">
        <div slot="content">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <b>Chọn file (.xlsx <a href="https://drive.google.com/uc?export=download&id=13l-Uw6013hW7-0E73V2bU5wN6mTIOCkh">Tải về file mẫu</a>)</b>
          </div>
          <div class="form-group col-md-8 col-sm-8 col-xs-8">
            <b-form-file
              v-model="file"
              :state="Boolean(file)"
              accept="text/xlsx"
              placeholder="Chọn file xlsx hoặc thả vào đây..."
              drop-placeholder="Thả file vào đây..."
              required
            ></b-form-file>
          </div>
        </div>
        <div slot="footer">
          <div class="d-flex">
            <b-button variant="success" class="w-150px" @click="handleImportOrder">
              Import
            </b-button>
            <b-button variant="warning" class="w-120px ml-3" @click="confirmImportOrder" :disabled="record_id === null">
              Xác nhận
            </b-button>
          </div>
        </div>
      </Box>
      <Box theme="box-primary" title="Danh sách import">
        <div slot="content">
          <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items"
                   show-empty>
            <template #table-busy>
              <div class="text-center my-2 mt-5 mb-5">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Đang tải...</strong>
              </div>
            </template>

            <template #empty="scope">
              <h4 class="text-center text-bold mt-5 mb-5" v-if="record_id === null">Không có dữ liệu</h4>
              <h4 class="text-center text-bold mt-5 mb-5" v-if="record_id !== null">File excel hợp lệ</h4>
            </template>
            <template v-slot:cell(error_codes)="data">
              <li v-for="error_code in data.item.error_codes" :key="error_code">
                {{ generateErrorFromErrorCode(error_code) }}
              </li>
            </template>
          </b-table>
        </div>
      </Box>
    </section>
  </div>
</template>

<script>
import Box from '../../components/Box'
import Utils from '../../common/utils'
import OrderApi from '../../api/orderApi'
import {mapGetters} from 'vuex'
import {IMPORT_ERROR_CODE} from '../../common/constant'

export default {
  name: 'ImportOrder',
  components: {
    Box,
  },
  data () {
    return {
      company: null,
      file: null,
      record_id: null,
      items: [],
      fields: [
        {
          key: 'row_number',
          label: 'Số dòng',
        },
        {
          key: 'id',
          label: 'STT',
        },
        {
          key: 'phone',
          label: 'Số điện thoại',
        },
        {
          key: 'name',
          label: 'Tên khách hàng',
        },
        {
          key: 'email',
          label: 'Email',
        },
        {
          key: 'data_source',
          label: 'Nguồn đơn hàng',
        },
        {
          key: 'data_channel',
          label: 'Nguồn kênh đơn hàng',
        },
        {
          key: 'care_note',
          label: 'Lịch sử CSKH',
        },
        {
          key: 'data_status',
          label: 'Trạng thái đơn hàng',
        },
        {
          key: 'data_sub_status',
          label: 'Trạng thái chi tiết',
        },
        {
          key: 'data_sub_status',
          label: 'Trạng thái chi tiết',
        },
        {
          key: 'error_codes',
          label: 'Mã lỗi',
        }
      ],
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
  },
  methods: {
    handleImportOrder () {
      if (this.file) {
        if (this.file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          Utils.warnToast(this.$bvToast, 'Định dạng file không đúng', 'Vui lòng tải lên file có định dạng xslt')
        } else {
          const formData = new FormData()
          formData.append('company_id', this.company.id)
          formData.append('file', this.file)
          this.loading = true
          OrderApi.importOrder(formData).then(res => {
            this.loading = false
            this.items = res.data.data.rows
            this.record_id = res.data.data.id
          }).catch(err => {
            this.loading = false
            Utils.handleError(this.$bvToast, err)
          })
        }
      } else {
        Utils.warnToast(this.$bvToast, 'Chưa chọn file', 'Vui lòng tải lên file')
      }
    },
    confirmImportOrder () {
      if (this.record_id) {
        if (this.items.length !== 0) {
          this.$bvModal.msgBoxConfirm('File excel import vẫn còn lỗi, bạn có chắc chắn bỏ qua các lỗi và xác nhận import không?', {
            title: false,
            buttonSize: 'sm',
            centered: true,
            size: 'sm',
            footerClass: 'p-2'
          }).then(res => {
            if (res) {
              this.loading = true
              OrderApi.confirmImportOrder({company_id: this.company.id, id: this.record_id}).then(res => {
                this.loading = false
                Utils.successToast(this.$bvToast, 'Import đơn hàng', 'Đã xác nhận import đơn hàng thành công')
                this.record_id = null
                this.items = []
              }).catch(err => {
                this.loading = false
                Utils.handleError(this.$bvToast, err)
              })
            }
          })
        } else {
          this.loading = true
          OrderApi.confirmImportOrder({company_id: this.company.id, id: this.record_id}).then(res => {
            this.loading = false
            Utils.successToast(this.$bvToast, 'Import đơn hàng', 'Đã xác nhận import đơn hàng thành công')
            this.record_id = null
            this.items = []
          }).catch(err => {
            this.loading = false
            Utils.handleError(this.$bvToast, err)
          })
        }
      }
    },
    generateErrorFromErrorCode (error_code) {
      return IMPORT_ERROR_CODE[error_code.toString()]
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/ImportOrder.vue